<template>
  <div class="background" :style="{ backgroundImage: bgImageUrl ? `url(${bgImageUrl})` : '' }">
    <div class="overlay"></div>
    <p class="panel-title">{{ $t('app.campaign.newPage.slidingPanel.customization.title') }}</p>
    <div v-if="currentCampaign" class="customization-panel-content">
      <div class="wrapper">
        <div class="content-wrapper">
          <div class="step-wrapper">
            <!-- <div class="step">{{ $t("app.campaign.single.editStepTitle") }}</div> -->
            <div class="form-wrapper">
              <p class="explanations">
                {{ $t("app.campaign.single.editCardExplanation") }} <br />
                {{ $t("app.campaign.single.editCardPersonalize") }}
              </p>
              <div class="campaign-layout">
                <CampaignCard style="width: 500px;" v-model="currentCampaign" @changeImage="uploadHeaderImage" @changePublicName="(e) => (currentCampaign.campaign.headline = e)" @changeJobTitle="(e) => (currentCampaign.campaign.job_title = e)" @changeJobDescription="(e) => (currentCampaign.campaign.tagline = e)" :mode="'edit'" :text_colour="currentCampaign.branding.text_color" :elem_colour="currentCampaign.branding.highlight_color" />
                <CampaignThemeCard @changeTextColour="(e) => (currentCampaign.branding.text_color = e)" @changeThemeColour="(e) => (currentCampaign.branding.highlight_color = e)" @setHeaderImage="uploadBackgroundImage" @setBackground="uploadBackgroundImage" @newBackground="uploadBackgroundImage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="edit-buttons">
      <Button class="secondary" :label="$t('app.campaign.newPage.slidingPanel.buttons.cancel')" @click="emit('close')"></Button>
      <Button class="green" :label="$t('app.campaign.newPage.slidingPanel.buttons.save')" @click="save"></Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.background {
  position: relative;
  padding: 40px;
  color: white;
  background-color: #000;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

}

.overlay {
  z-index: 20;
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7); /* adjust opacity */
}

.edit-buttons {
  position: relative;
  z-index: 21;
  margin-top: 12px;
  width: 100%;
  display: flex;
  gap: 12px;
  justify-content: center;
}

::v-deep(.quillEditor) {
  width: 100%;
  max-width: 100%;

  .ql-toolbar {
    border: 1px solid var(--secondary-color) !important;
    border-radius: 6px 6px 0px 0px;
    color: var(--secondary-color) !important;
  }
  .ql-editor {
    padding-top: 12px !important;
    font-size: 16px !important;
    font-family: $bioSans;
    line-height: 1.3 !important;
    overflow-y: auto;
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
  }
  .ql-editor.ql-blank::before {
    color: var(--secondary-color) !important;
  }
  .ql-container {
    border: 1px solid var(--secondary-color) !important;
    border-top: 0px !important;
    border-radius: 0px 0px 6px 6px;
    min-height: 130px;
  max-height: 130px;
  }
  .ql-tooltip {
    background: var(--white-color) !important;
    color: var(--secondary-color) !important;
  }
  .ql-snow .ql-stroke {
    stroke: var(--secondary-color) !important;
  }
  
  .quill-editor input[type="text"],
  .quill-editor input[type="number"],
  .quill-editor input[type="email"],
  .quill-editor input[type="tel"],
  .quill-editor input[type="password"] {
    color: var(--secondary-color) !important;
  }
  
  /* Change the color on hover */
  .ql-toolbar .ql-formats button:hover {
    background-color: var(--light-grey-color) !important;
  }
  .ql-snow.ql-toolbar button.ql-active {
    background-color: var(--light-grey-color) !important;
  }
}

.panel-title {
  position: relative;
  z-index: 21;

  color: $white-color;
  font-family: $bioSans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 22px;
}

.customization-panel-content {
  position: relative;
  display: flex;
  gap: 40px;
  width: 85vw;
  z-index: 21;

  .campaign-card {
    //flex-basis: 40%;
    flex-shrink: 0;

    ::v-deep(input) {
      color: $white-color !important;
    }
  }

  .explanations {
    font-size: 14px;
  }

  .camp-open-theme-zone {
    position: relative;
    margin: 16px 0;
  }

  .camp-theme-card {
    position: relative;
    margin: 16px 0;
    font-size: 14px;

    ::v-deep(.camp-theme-title) {
      font-size: 14px;
    }

    ::v-deep(.camp-theme-text) {
      font-size: 14px;
    }

    ::v-deep(.camp-theme-upload-title) {
      font-size: 14px;
    }

    ::v-deep(.camp-theme-colour-title) {
      font-size: 14px;
    }

    ::v-deep(.camp-theme-colour-code) {
      font-size: 14px;
    }

    ::v-deep(.camp-theme-upload-selector-bt) {
      font-size: 14px;
    }

    ::v-deep(.camp-theme-upload-file-name) {
      font-size: 14px;
    }

    ::v-deep(.vs__search) {
      font-size: 12px;
    }
  }

  .customization-inputs {
    flex-basis: 60%;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .header-customization {
      display: flex;
      gap: 16px;
      flex-wrap: nowrap;

      .input {
        flex: 1;
      }
    }

    .field-label {
      padding-bottom: 8px;
      font-family: $bioSans;
      color: var(--secondary-color);
      font-size: 16px;

      span {
        font-size: 15px;
      }
    }

    .description-customization {
      display: flex;
      flex-direction: column;
    }

    .images-customization {
      display: flex;
      gap: 16px;

      .half {
        flex-basis: 50%;
        flex-shrink: 1;
      }

      .file-selector {
        border-radius: 4px;
        border: 1px solid;
        border-color: var(--secondary-color);
        display: flex;
        align-items: center;

        .camp-theme-upload-selector-bt {
          flex-shrink: 0;
          padding: 12px;
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
          font-weight: bold;
          font-family: $bioSans;
          font-weight: 400;
          color: var(--secondary-color);
          font-size: 12px;
          border-right: 1px solid var(--secondary-color);
          cursor: pointer;
  
          &:hover {
            background-color: var(--light-white-color);
          }
        }
  
        .camp-theme-upload-input {
          display: none;
        }
  
        .camp-theme-upload-file-name {
          min-width: 0;
          font-size: 14px;
          border: none !important;
          color: var(--grey-50-color) !important;
          flex-shrink: 1;
          overflow-x: hidden;
        }
  
        .camp-theme-remove-file {
          padding-right: 12px;
          cursor: pointer;
        }
      }

    }
    
    .colors-customization {
      display: flex;
      gap: 16px;

      .camp-theme-colour-subsection {
        display: flex;
        margin-top: 8px;
      }

      .camp-theme-colour-title {
        padding-top: 16px;
        font-family: $bioSans;
        color: var(--secondary-color);
        font-size: 16px;
      }

      .camp-theme-colour-picker {
        border: none; /* Remove the default border */
        outline: none; /* Remove the outline when focused */
        padding: 0px !important;
        margin: 0px !important;
        width: 65px;
        height: 48px;
        cursor: pointer;
        background: none; /* Remove background to prevent any default styling */
        -webkit-appearance: none; /* Remove default webkit appearance */
      }
      .camp-theme-colour-picker::-webkit-color-swatch {
        border: none; /* Remove the default swatch border in WebKit browsers */
        border-radius: 4px;
      }

      .camp-theme-colour-picker::-moz-color-swatch {
        border: none; /* Remove the default swatch border in Firefox */
        border-radius: 4px;
      }

      .camp-theme-colour-code {
        width: 100px;
        background-color: var(--white-color);
        border: 1px solid var(--secondary-color);
        padding: 0px !important;
        padding-left: 12px !important;
        margin: 3.5px !important;
        font-weight: 400;
        color: var(--secondary-color) !important;
        font-size: 16px;
      }

      .camp-theme-text-colour {
        margin-top: 8px;
        display: flex;
        padding-top: 12px;
        gap: 16px;
      }

      .helper {
        padding-top: 8px;
        color: var(--secondary-color);
        font-family: $bioSans;
        font-size: 14px;
        font-style: italic;
        font-weight: 400;
        line-height: 16px;
        opacity: 0.8;
      }
    }
  }
}
</style>

<script setup lang="ts">
import CampaignCard from '@/components/global/CampaignCard.vue';
import { CampaignCreation } from '@/types/campaign';
import { useToast } from 'vue-toastification';

const toast = useToast();
const { t } = useI18n();
const { uploadImage } = useImageStore();
const route = useRoute();

const selectFileText = t("app.campaign.card.personalisation.selectFilePlaceholder"); // Default text colour
const bannerFileName = ref(selectFileText);
const bannerfileSelected = ref(false);

const backgroundFileName = ref(selectFileText);
const backgroundfileSelected = ref(false);


const props = defineProps<{
  campaign: CampaignCreation,
}>();

const currentCampaign: Ref<CampaignCreation> = ref(undefined);

const emit = defineEmits<{
  (e: 'save', value: CampaignCreation): void
  (e: 'close'): void
}>();

function save() {
  emit('save', structuredClone(toRaw(currentCampaign.value)));
  emit('close');
}

const quillOptions = computed(() => {
  return {
    theme: "snow",
    placeholder: t("app.campaign.card.descriptionPlaceholder", {}, { locale: currentCampaign.value.campaign.locale }),
    modules: {
      toolbar: [["bold", "italic", "underline"], ["link"]],
    }
  }
});

const bgImageUrl = computed(() => {
  if (!currentCampaign?.value?.branding?.background_image_id || !currentCampaign.value?.branding?.background_image_id.length) return undefined;
  const url = getImage(currentCampaign.value.branding.background_image_id);
  return url;
});

const uploadHeaderImage = async (file) => {

  const maxSize = 1024 * 2048; // 2Mo

  if (file) {
    if (!["image/png", "image/jpeg", "image/gif"].includes(file.type)) {
      toast.error(t('app.campaign.newPage.slidingPanel.customization.imageWrongFormat'));
      return;
    }

    if (file.size > maxSize) {
      toast.error(t('app.campaign.newPage.slidingPanel.customization.imageTooLarge'));
      return;
    }
    bannerFileName.value = file.name;
    bannerfileSelected.value = true;

    const { image_id } = await uploadImage(route.params.companyId as string, "campaign_public_image", file);

    if (image_id) {
      currentCampaign.value.branding.banner_image_id = image_id;
    } else {
      toast.error(t("app.campaign.single.imageUploadError"));
    }
  } else {
    //There was an image now there is none
    currentCampaign.value.branding.banner_image_id = null;
  }
};

const uploadBackgroundImage = async (file) => {
  const maxSize = 1024 * 2048; // 2Mo

  if (file) {
    if (!["image/png", "image/jpeg", "image/gif"].includes(file.type)) {
      toast.error(t('app.campaign.newPage.slidingPanel.customization.imageWrongFormat'));
      return;
    }

    if (file.size > maxSize) {
      toast.error(t('app.campaign.newPage.slidingPanel.customization.imageTooLarge'));
      return;
    }
    backgroundFileName.value = file.name;
    backgroundfileSelected.value = true;

    const { image_id } = await uploadImage(route.params.companyId as string, "campaign_public_bg_image", file);

    if (image_id) {
      currentCampaign.value.branding.background_image_id = image_id;
    } else {
      toast.error(t("app.campaign.single.imageUploadError"));
    }
  } else {
    //There was an image now there is none
    currentCampaign.value.branding.background_image_id = null;
  }
};

function removeHeaderImage() {
  bannerFileName.value = selectFileText;
  bannerfileSelected.value = false;
  currentCampaign.value.branding.banner_image_id = null;
}

function removeBackgroundImage() {
  backgroundFileName.value = selectFileText;
  backgroundfileSelected.value = false;
  currentCampaign.value.branding.background_image_id = null;
}

onMounted(() => {
  if (props.campaign) {
    currentCampaign.value = structuredClone(toRaw(props.campaign));
  }
});
</script>